export default __webpack_public_path__ + "static/media/jaipur1.b799150a.jpg";